/**
 * Warstwa API: SKRZYNKA ZEWNĘTRZNA (polecenie właściciela 2026-09-30, obszar D).
 * Trasy backendu: api/tickets/external-inbox (SkrzynkaZewnetrznaController) oraz przełącznik skrzynki
 * i podgląd domen własnych w api/configurations (ConfigurationsController).
 *
 * „Zgłoszenia spoza domeny nie powinny generować ticketu, tylko być tam wysłane — bez ewidencji obsługi,
 * że przyjęte zgłoszenie itp.” Wiadomość spoza domen spółek czeka tu na decyzję człowieka:
 * „Przekształć w zgłoszenie” albo „Odrzuć”.
 *
 * Kontrakt: `attach(api)` dostaje instancję axios z apiService.js i zwraca obiekt nazwanych metod
 * (jedno miejsce doczepienia: src/api/modules/index.js). Adresy BEZ własnego prefiksu „/api” — baseURL już go ma.
 */
export function attach(api) {
    return {
        /**
         * Lista wiadomości w zakresie (bez treści). status: "oczekuje" | "przeksztalcona" | "odrzucona".
         * powod (opcjonalny): "spoza_domen" | "domena_z_filtra" | "modul_wylaczony" — brak = wszystkie powody.
         */
        getExternalInbox: ({ status = "oczekuje", moduleCode, take, powod } = {}) =>
            api.get("/tickets/external-inbox", { params: { status, moduleCode, take, powod: powod || undefined } }),

        /**
         * Plakietka kafelka „Zewnętrzne” — { oczekujace }. Ten sam predykat zakresu co lista (licznik == lista).
         * Bez `powod` liczy wszystkie powody (poczta spoza domen firmy i z domen na liście filtrów razem).
         */
        getExternalInboxCount: (moduleCode, powod) =>
            api.get("/tickets/external-inbox/licznik", { params: { moduleCode, powod: powod || undefined } }),

        /** Podgląd jednej wiadomości (z treścią i HTML do sanityzacji). */
        getExternalInboxItem: (id) => api.get(`/tickets/external-inbox/${id}`),

        /**
         * „Przekształć w zgłoszenie” → { ticketId, ticketNumber }.
         * Auto-odpowiedź „przyjęliśmy zgłoszenie” jest DOMYŚLNIE WYŁĄCZONA — wychodzi tylko na jawne życzenie.
         */
        convertExternalInboxItem: (id, { kategoriaId = null, wyslijPotwierdzenie = false } = {}) =>
            api.post(`/tickets/external-inbox/${id}/przeksztalc`, { kategoriaId, wyslijPotwierdzenie }),

        /** „Odrzuć” — niczego nie kasuje (status, powód, kto, kiedy). */
        rejectExternalInboxItem: (id, powod = "") =>
            api.post(`/tickets/external-inbox/${id}/odrzuc`, { powod }),

        /**
         * [poprawka właściciela 2026-10-01] PROSTE ZAMKNIĘCIE — jedna albo zaznaczone wiadomości, bez formularza →
         * { zamkniete, pominiete }. Zapis jak „Odrzuć” (powód „Zamknięte bez zgłoszenia”), klucz TicketClose, wpis audytu.
         */
        closeExternalInboxItems: (ids) => api.post("/tickets/external-inbox/zamknij", { ids }),

        /** Przywrócenie odrzuconej wiadomości do oczekujących. */
        restoreExternalInboxItem: (id) => api.post(`/tickets/external-inbox/${id}/przywroc`),

        /** Stan przełącznika „wiadomości spoza domen spółek → Zewnętrzne” skrzynki (okno edycji skrzynki). */
        getMailboxExternalRule: (configurationId) =>
            api.get(`/configurations/${configurationId}/zewnetrzne-do-skrzynki`),

        /** Wyliczona lista domen własnych spółek — podgląd w oknie skrzynki. */
        getOwnCompanyDomains: () => api.get("/configurations/domeny-wlasne"),
    };
}
